"use client";
import React from "react";
import ViewToggle from "../../../components/ViewToggle";

export default function ViewToggleWrapper({
  cityName,
  stateName,
  filterval,
  defaultSelected = "Top Lists",
}) {
  const handleViewToggle = (view) => {
    if (view === "Map View") {
      // Set localStorage before navigation
      localStorage.setItem("ispagemain", "true");
      localStorage.setItem("selectdnhranking", filterval);
      // Open in new window
      window.open(`/?address=${cityName}, ${stateName}, USA`, "_blank");
    }
    // If "Top Lists" is clicked, do nothing (already on this view)
  };

  return (
    <ViewToggle onToggle={handleViewToggle} defaultSelected={defaultSelected} />
  );
}
